import { Injectable, OnInit } from "@angular/core";
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { environment } from "../../../environments/environment";
import { HttpParams } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { appService } from "../../_services/app.service";
import { ToastrService } from "ngx-toastr";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
// import { NgxSecureCookieService } from 'ngx-secure-cookie'
// import { NgxEncryptCookieService } from 'ngx-encrypt-cookie'
import { EncryptPipe, DecryptPipe } from '../../auth/_services/encrypt-decrypt.pipe';
import { Token } from "@angular/compiler";
const LNG_KEY = "SELECTED_LANGUAGE";

@Injectable()
export class AuthenticationService implements OnInit {
  //added by vithujan 01-11-2022
  TokenInfo: any = {};
  //end
  constructor(
    private http: Http,
    private cookieService: CookieService,
    private _appService: appService,
    private toastr: ToastrService,
    private service: TranslateConfigService,
    private translate: TranslateService,
    // private cookie: NgxEncryptCookieService
    // private cookie: NgxSecureCookieService
    private encryptpipe: EncryptPipe,
    private decryptpipe: DecryptPipe
  ) { }

  ngOnInit() { }

  login(email: string, password: string) {
    localStorage.clear();
    this.cookieService.deleteAll();
    let clientId = location.hostname;
    let headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    let params = new HttpParams();
    params = params.append("userName", email);
    params = params.append("password", password);
    params = params.append("clientId", clientId);
    params = params.append("grant_type", "password");
    return this.http
      .post(environment.apiUrl + "Token", params.toString(), {
        headers: headers,
      })
      .map((response: Response) => {
        // login successful if there's a jwt token in the response
        let user = response.json();
        console.log("first response", user);

        // added by vithujan 01-11-2022
        var current_url = window.location.href;
        var url_object = new URL(current_url);
        var domain = url_object.hostname;
        //end
        if (user && user.access_token) {
          // this.decryptpipe.transform(user.userId);
          this.cookieService.set("UserId", JSON.stringify(this.encryptpipe.transform(user.userId)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          this.cookieService.set("SetUserRole", JSON.stringify(this.encryptpipe.transform(user.userRole)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          // this.cookieService.set("User", JSON.stringify(user));
          this.cookieService.set("user_access_token", JSON.stringify(this.encryptpipe.transform(user.access_token)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          this.cookieService.set("EmailId", JSON.stringify(this.encryptpipe.transform(user.userName)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          this.cookieService.set("UserFullName", JSON.stringify(this.encryptpipe.transform(user.userFullName)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          this.cookieService.set("FreightSpend", JSON.stringify(this.encryptpipe.transform(user.FreightSpend)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          this.cookieService.set("DefaultCompany", JSON.stringify(this.encryptpipe.transform(user.defaultCompany)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          this.cookieService.set("ProfilePhotoName", JSON.stringify(this.encryptpipe.transform(user.ProfilePhotoName)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          this.cookieService.set("TenantId", JSON.stringify(this.encryptpipe.transform(user.TenantId)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          this.cookieService.set("UserCount", JSON.stringify(this.encryptpipe.transform(user.UserCount)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);
          this.cookieService.set("SystemVersion", JSON.stringify(this.encryptpipe.transform(user.SystemVersion)), undefined, undefined, undefined, environment.apiUrl == 'http://tms.theptpl.com/' ? false : true);

          let UserRole = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
          var Roles = JSON.parse(UserRole);

          //added by vithujan 01-11-2022
          // this.saveSysToken(user.access_token, JSON.stringify(user.userId).replace(/"/g, ''));
          //end

          setTimeout(() => {
            //Setting Default language from Database To local
            this._appService.Getbyuserid("Signup", "getDefaultLangForUser", user.userId).subscribe((res) => {
              var langlist = res as any;
              var defaultLang = langlist[0].DefaultLanguage;
              this.translate.use(defaultLang);
              localStorage.setItem(LNG_KEY, defaultLang);
            });
            // ends here

            this._appService.GetById("RoleRights", "GetRightsByRole", Roles).subscribe((response) => {
              localStorage.setItem("rights_assigned", JSON.stringify(response));
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });

            let id = user.userId;
            this._appService.GetById("User", "GetUserTypeRightsList", id).subscribe((response) => {
              localStorage.setItem("user_Type_Rights", JSON.stringify(response));
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });

            //Added By Ketan on 22-Oct-2020
            this._appService.GetById("Common", "GetSystemSettingByName", "WhiteLabel").subscribe((response) => {
              if (response == "1") {
                localStorage.setItem("whitelabelFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("whitelabelFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });
            //Ended By Ketan on 22-Oct-2020

            //Added by Pawan Darji on 07-01-2020
            this._appService.GetById("Common", "GetSystemSettingByName", "DriverPOD").subscribe((response) => {
              if (response == "1") {
                localStorage.setItem("PODFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("PODFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });

            this._appService.GetById("Common", "GetSystemSettingByName", "DriverSignature").subscribe((response) => {
              if (response == "1") {
                localStorage.setItem("SignatureFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("SignatureFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });

            this._appService.GetById("Common", "GetSystemSettingByName", "DriverPODOdometer").subscribe((response) => {
              if (response == "1") {
                localStorage.setItem("OdometerFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("OdometerFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });
            //Ends here 

            // add kevin 14/07/2020
            let Userid = user.userId;
            this._appService.GetById("OrdersByVehicle", "checkTransporter", Userid).subscribe((response) => {
              localStorage.setItem("isTransporter", JSON.stringify(response[0].isTransporter));
              localStorage.setItem("isCustomer", JSON.stringify(response[0].isCustomer));
              localStorage.setItem("userComanyId", JSON.stringify(response[0].Id));
              localStorage.setItem("userComanyName", JSON.stringify(response[0].companyName));
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });

            this._appService.GetById("Common", "GetSystemSettingByName", "eWayBill").subscribe((response) => {
              if (response == "1") {
                localStorage.setItem("eWayBillFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("eWayBillFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });

            this._appService.GetById("Common", "GetSystemSettingByName", "THC").subscribe((response) => {
              if (response == "1") {
                localStorage.setItem("THCFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("THCFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });
            // end

            //added by pawan darji on 02-11-2020
            this._appService.Get("OrdersByVehicle", "getSmsSystemSetting").subscribe((res) => {
              const value = JSON.stringify(res);
              localStorage.setItem("smsFlag", value);
            }, (err) => {
              console.log(err);
            });

            this._appService.Get("OrdersByVehicle", "getHubAndSpokeSystemSetting").subscribe((res) => {
              const value = JSON.stringify(res);
              localStorage.setItem("hubAndSpokeFlag", value);
            }, (err) => {
              console.log(err);
            });

            this._appService.Get("OrdersByVehicle", "GetTaxServiceSetting").subscribe((res) => {
              const value = JSON.stringify(res);
              localStorage.setItem("SalesFlag", value);
            },
              (err) => {
                console.log(err);
              }); // ends here

            // add kevin 11/06/2021
            this._appService.GetById("OrdersByVehicle", "checkIsOceanFreightExport", user.TenantId.replace(/"/g, '')).subscribe((response) => {
              if (response[0].isExport == 'false') {
                localStorage.setItem("isFreightExport", JSON.stringify(false));
              } else {
                localStorage.setItem("isFreightExport", JSON.stringify(true));
              }
              // localStorage.setItem("isFreightExport", JSON.stringify(response[0].isExport));
            },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              });
            // end

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'OdemeteHideShow').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("ShowHideFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("ShowHideFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'fuelPump').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("fuelPumpFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("fuelPumpFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'AutoBillGenerateTHCStage').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("AutoBillGenerateTHCStageFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("AutoBillGenerateTHCStageFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'ManualLRNumberOnOff').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("ManualLRNumberOnOffFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("ManualLRNumberOnOffFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'SecondTripProceesLinkFormat').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("SecondTripProceesLinkFormatFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("SecondTripProceesLinkFormatFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'Trip_assignVehicle_to_bookingCompleted_stage').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("Trip_assignVehicle_to_bookingCompleted_stageFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("Trip_assignVehicle_to_bookingCompleted_stageFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'HubSpoke').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("hubAndSpokeFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("hubAndSpokeFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'E_Invoice_On_Off').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("E_Invoice_On_OffFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("E_Invoice_On_OffFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'ManualPlanningDestinationValuesFromPinCodeDeliveryBranch').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'OrderListFilterOption_OPQAppWise').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("OrderListFilterOption_OPQAppWiseFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("OrderListFilterOption_OPQAppWiseFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'MultiPickupTripOnOff').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("MultiPickupTripOnOffFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("MultiPickupTripOnOffFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'ContactPersonNameInTripListPage').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("ContactPersonNameInTripListPageFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("ContactPersonNameInTripListPageFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'GeoFencingOnOff').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("GeoFencingOnOffFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("GeoFencingOnOffFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'DestinationGateInGateOutMergeConfirmDeliver').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("DestinationGateInGateOutMergeConfirmDeliverFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("DestinationGateInGateOutMergeConfirmDeliverFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'SecondBookingBasedOnDeliveryBranch').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("SecondBookingBasedOnDeliveryBranchFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("SecondBookingBasedOnDeliveryBranchFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'AddEnquiryInOrders').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("AddEnquiryInOrdersFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("AddEnquiryInOrdersFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'productFulfillmentWiseBooking').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("productFulfillmentWiseBookingFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("productFulfillmentWiseBookingFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'THCAdvancePercentageApproveReject').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("THCAdvancePercentageApproveRejectFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("THCAdvancePercentageApproveRejectFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'SIMTracking').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("SIMTrackingFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("SIMTrackingFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'HideShow').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("HideShowOrderRistInsuarnceGSTFreightFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("HideShowOrderRistInsuarnceGSTFreightFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'UseManualLRNumber').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("UseManualLRNumberFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("UseManualLRNumberFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'GenerateProformaInvoiceNumber').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("GenerateProformaInvoiceNumberFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("GenerateProformaInvoiceNumberFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'NetworkAuthorizeMandatoryForOrder').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("NetworkAuthorizeMandatoryForOrderFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("NetworkAuthorizeMandatoryForOrderFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'ShippingLineAndCHA').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("ShippingLineAndCHAFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("ShippingLineAndCHAFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'TripRouteBaseOnDeliveryDate').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("TripRouteBaseOnDeliveryDateFlag", JSON.stringify(true));
              } else {
                localStorage.setItem("TripRouteBaseOnDeliveryDateFlag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'whs_IsWarehouseMenu').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("whs_IsWarehouseMenu_Flag", JSON.stringify(true));
              } else {
                localStorage.setItem("whs_IsWarehouseMenu_Flag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'WMS_WarehouseFor_sawariya').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("WMS_WarehouseFor_sawariya_Flag", JSON.stringify(true));
              } else {
                localStorage.setItem("WMS_WarehouseFor_sawariya_Flag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });

            this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'so_inwardSameWarehouseMultipleBranch').subscribe((response) => {
              if (response[0].Value == "1") {
                localStorage.setItem("so_inwardSameWarehouseMultipleBranch_Flag", JSON.stringify(true));
              } else {
                localStorage.setItem("so_inwardSameWarehouseMultipleBranch_Flag", JSON.stringify(false));
              }
            },
              (err) => {
                this.toastr.error("Error occurred while fetching Status data !", "error");
              });
          }, 1000);
        }
      });
  }

  //added by vithujan 01-11-2022
  saveSysToken(token: any, userId: any) {
    this.TokenInfo.Token = token;
    this.TokenInfo.UserId = userId;

    this._appService.Post('User', 'SaveSysToken', this.TokenInfo).subscribe(
      (data) => {
        this.TokenInfo = {};
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  DeleteSysToken(userId: any, token: any) {
    this.TokenInfo.UserId = userId;
    this.TokenInfo.Token = token;

    this._appService.Post('User', 'DeleteSysToken', this.TokenInfo).subscribe(
      (data) => {
        this.TokenInfo = {};

        // remove user from local storage to log user out
        localStorage.removeItem("rights_assigned");
        localStorage.removeItem("user_Type_Rights");
        this.cookieService.delete("UserId");
        // this.cookieService.delete("SetUserRole");
        this.cookieService.delete("user_access_token");
        this.cookieService.delete("EmailId");
        this.cookieService.delete("UserFullName");
        this.cookieService.delete("FreightSpend");
        this.cookieService.delete("DefaultCompany");
        this.cookieService.delete("ProfilePhotoName");
        this.cookieService.delete("TenantId");
        this.cookieService.delete("UserCount");
        this.cookieService.delete("SystemVersion");
        // added by vithujan 28-12-2022
        localStorage.clear();
        //end
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }
  //end

  ReloadPage() {
    // window.location.reload();
  }

  logout(userId) {
    var UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    var token = this.decryptpipe.transform(JSON.parse(this.cookieService.get("user_access_token")));

    var objSys: any = {};
    this._appService.Post('Account', 'LogoutNew', objSys).subscribe(
      (data) => {
        this.DeleteSysToken(UserId, token);
      },
      (err) => {
      }
    );
  }
}
